/* stylelint-disable */
import Styled, { css } from 'styled-components';
import ProductAltImages from '../views/ProductAltImages';

export const StyledItemContainerInner = Styled.div`
  display: flex;
  position: relative;
  margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS} ${(props) =>
  props.theme.spacing.ELEM_SPACING.MED_1};
  border: 1px solid ${(props) => props.theme.colors.DIVIDER};
  border-radius: 5px;
`;

export const StyledNoItemAvailableWrapper = Styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isFavoriteView ? `margin-top: 7px` : '')}
  }
`;

export const StyledHorizontalRule = Styled.hr`
  width: 100%;
  border-top: #E7E7E775;
`;

export const StyledProductImageContainer = Styled(ProductAltImages)`
  margin:0px ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
`;

export const StyledFavoriteEditItemButton = Styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isItemView ? 'height: 22px;' : '')};
  }
`;

export const StyledNoRatingSpaceMobileSNJ = Styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 34px;
  }
`;

export const AtbIcon = Styled.button`
  cursor: pointer;
  background-size: contain;
  height: auto;
  width: auto;
  border: none;
  padding: 0;
  bottom: 10px;
  right: 16px;
  position: absolute;
  background-color: ${(props) => props.theme.colors.WHITE};
  @media ${(props) => props.theme.mediaQuery.small} {
    bottom: 16px;
  }
  img{
    @media ${(props) => props.theme.mediaQuery.small} {
      height: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 42px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 40px;
    }
  }
`;
AtbIcon.displayName = 'SubmitButtonIcon';

const styles = css`
  width: 100%;
  height: 100%;

  .list-price-container {
    padding-right: 10px;
  }

  .list-price {
    text-decoration: line-through;
    color: ${(props) => props.theme.colorPalette.gray[600]};
  }

  .product-title-container {
    margin-top: 0;
    box-sizing: border-box;
    padding-top: 18px;
  }

  .product-brand-plp {
    color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
    ${(props) => (props.isNewPLPAtbCardTileEnabled ? 'margin-bottom:0;' : '')}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    }
    font-size: ${(props) => (props.isRecommendationProductInfoEnabled ? `10px` : ``)};
  }

  .video-container {
    min-height: 182px;
    align-items: center;
    display: flex;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 320px;
      cursor: pointer;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: 245px;
    }
  }

  .purchase-section {
    margin-top: 16px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .is-purchase-label {
    display: inline-block;
    padding-left: 2px;
  }

  .create-wish-list-section {
    padding: 8px 16px 20px;
    font-size: 14px;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .create-wish-list-header {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 16px;
  }

  .wish-list-name {
    text-transform: capitalize;
  }

  .wish-list-count-section {
    text-transform: lowercase;
    display: inline-block;
    padding-right: 2px;
    padding-top: 3px;
  }

  .default-list-item,
  .default-list-count {
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  }

  .create-new__button {
    margin-top: 28px;
  }

  .product-sku-info-container {
    font-size: 12px;
    color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
    text-transform: capitalize;
  }

  .wish-list-item-section {
    display: flex;
    justify-content: space-between;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }

  .wish-list-item__button {
    text-align: left;
    width: 100%;
    &:focus {
      background: transparent;
    }
  }

  .edit-fav-item__button {
    text-align: center;
    text-decoration: underline;
  }

  .wish-list-tick-mark {
    vertical-align: bottom;
  }

  .sold-out-section {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-color: rgba(255, 255, 255, 0.7);
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .container-price {
    white-space: nowrap;
    ${(props) => (props.isFavoriteView ? '' : 'min-height: 39px')};
  }

  .top-badge-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(50%);
  }

  .top-badge-container div:last-child {
    margin-right: 0;
  }

  .extended-sizes-text {
    margin-top: 8px;
  }

  .relative {
    position: relative;
  }
  .item-container-inner {
    background-color: white;
    margin: 4px 18px;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .container-price {
      ${(props) => (props.isFavoriteView ? `min-height: 50px` : 'min-height: 47px')};
      margin-top: 4px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .container-price {
      margin-top: 0px;
    }

    &:hover {
      .button-prev {
        display: block;
      }
      .button-next {
        display: block;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 100%;
    .close-btn-icon {
      width: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .product-image-container {
    display: flex;
    align-items: center;
    width: 101px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  }

  .multiline-ellipsis {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    width: 90%;
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  }
  .container-price p {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }

  .container-price span {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }

  .loadImage {
    width: 101px;
    max-width: none;
  }
`;
export default styles;
